export interface IGenderStatic {
  title: string;
  tag: string;
}

export const FEMALE_GENDER: IGenderStatic = { title: 'Woman', tag: 'F' };
export const NON_BINARY_GENDER: IGenderStatic = { title: 'Non-binary', tag: 'U' };
export const MALE_GENDER: IGenderStatic = { title: 'Man', tag: 'M' };

export const GENDER_LIST: IGenderStatic[] = [
  FEMALE_GENDER,
  NON_BINARY_GENDER,
  MALE_GENDER
];
